import { useRouter } from "next/router";
import { useEffect } from "react";

export default function LegacyAvailableProviders() {
  const router = useRouter();

  useEffect(() => {
    router.replace({
      pathname: `/connections`,
      query: { ...router.query, type: "available" },
    });
  }, [router]);
  return null;
}
